export default __webpack_public_path__ + "static/Promise-7342bf5500f7b12a1b73ff48861d1f81.png";